import LocationDateInfo from "./LocationDateInfo";
import React from "react";
import ResultsButton from "./ResultsButton";
import ScheduleButton from "./ScheduleButton";
import { CompetitionWithId } from "../../interfaces/ICompetitions";
import { Grid, TableCell, Typography } from "@mui/material";
import {
  hasHiddenRoundsBecauseOfFinals,
  hasVisibleFinalResults,
  hasVisibleRoundResults,
} from "../../utils/resultPublicationUtils";

interface CompetitionTableRowProps {
  competition: CompetitionWithId;
  /** Gdy false — brak opublikowanego harmonogramu; przycisk „Harmonogram” ukryty */
  showScheduleButton: boolean;
  onRoundResultsClick: (competitionId: string) => void;
  onFinalResultsClick: (competitionId: string) => void;
  onScheduleClick: (competitionId: string) => void;
}

function CompetitionTableRow({
  competition,
  showScheduleButton,
  onRoundResultsClick,
  onFinalResultsClick,
  onScheduleClick,
}: CompetitionTableRowProps) {
  const categories = competition.categories || [];

  const handleRoundButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onRoundResultsClick(competition.id);
  };

  const handleFinalButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onFinalResultsClick(competition.id);
  };

  const handleScheduleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onScheduleClick(competition.id);
  };

  const hasRoundResults = categories.some((category) => hasVisibleRoundResults(competition, category));
  const hasFinalResults = categories.some((category) => hasVisibleFinalResults(category));
  const areRoundResultsBlocked =
    !hasRoundResults && categories.some((category) => hasHiddenRoundsBecauseOfFinals(competition, category));

  return (
    <TableCell sx={{ py: 1.5 }}>
      <Grid container spacing={1}>
        {/* Pierwszy wiersz: Nazwa turnieju */}
        <Grid item xs={12} sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography
            variant="subtitle1"
            component="div"
            color="primary"
            sx={{
              fontWeight: 600,
              fontSize: { xs: "0.875rem", sm: "0.9375rem" },
              lineHeight: 1.3,
              wordBreak: "break-word",
              mb: { xs: 0.5, sm: 0.5 },
            }}
          >
            {competition.name}
          </Typography>
        </Grid>

        {/* Drugi wiersz: Lokalizacja, data i przycisk */}
        <Grid item xs={12}>
          <Grid container spacing={1} alignItems="center" justifyContent="space-between">
            {(competition.location || competition.date) && (
              <Grid item xs="auto">
                <LocationDateInfo location={competition.location} date={competition.date} />
              </Grid>
            )}
            <Grid
              item
              xs="auto"
              sx={{
                display: "flex",
                gap: 1,
                flexWrap: "wrap",
                ml: "auto",
              }}
            >
              {showScheduleButton ? <ScheduleButton onClick={handleScheduleClick} /> : null}
              {!areRoundResultsBlocked &&  hasRoundResults && (
                <ResultsButton
                  label="Wyniki eliminacji"
                  onClick={handleRoundButtonClick}
                  disabled={!hasRoundResults}
                />
              )}
              {hasFinalResults && (
                <ResultsButton
                  label="Wyniki końcowe"
                  onClick={handleFinalButtonClick}
                  disabled={!hasFinalResults}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </TableCell>
  );
}

export default React.memo(CompetitionTableRow);
